// extracted by mini-css-extract-plugin
export default {"hyphens":"kyxcO","imagePlaceholderTitle":"_7KysV","imagePlaceholderText":"KTr4X","imagePlaceholder":"CXJrw","fullImage":"unfgR"};